import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Carousel, CarouselItem, CarouselIndicators, CardBody, Card, Col } from "reactstrap";
import type { DashboardInsight } from "../../utils/dashboardMetrics";

interface NewSliderProps {
  insights: DashboardInsight[];
  loading?: boolean;
}

const NewSlider = ({ insights, loading }: NewSliderProps) => {
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [animating, setAnimating] = useState<boolean>(false);
  const items = insights.length
    ? insights
    : [
        {
          id: "empty",
          icon: "information-outline",
          title: "No Alerts",
          description: "No operational highlights for this period.",
          to: "/dashboard",
        },
      ];

  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const goToIndex = (newIndex: number) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };

  const slides = items.map((item) => {
    return (
      <CarouselItem
        tag="div"
        key={item.id}
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
      >
        <div className="text-center p-2">
          <i className={"mdi mdi-" + item.icon + " widget-box-1-icon"}></i>
          <div className="avatar-md m-auto">
            <span className="avatar-title rounded-circle bg-light-subtle text-white font-size-24">
              <i className={"mdi mdi-" + item.icon}></i>
            </span>
          </div>
          <h4 className="mt-3 lh-base fw-normal text-white">
            <b>{item.title}</b>
          </h4>
          <p className="text-white-50 font-size-13">
            {loading ? "Loading insights..." : item.description}
          </p>
          <Link to={item.to} className="btn btn-light btn-sm">
            View details <i className="mdi mdi-arrow-right ms-1"></i>
          </Link>
        </div>
      </CarouselItem>
    );
  });

  return (
    <Col xl={4}>
      <Card className="bg-primary text-white shadow-primary card-h-100">
        <CardBody>
          <Carousel
            activeIndex={activeIndex}
            next={next}
            previous={previous}
            className="pb-4"
          >
            {slides}
          </Carousel>
          <CarouselIndicators
            tag="button"
            items={items}
            activeIndex={activeIndex}
            onClickHandler={goToIndex}
            className="carousel-indicators-rounded m-0"
          />
        </CardBody>
      </Card>
    </Col>
  );
};

export default NewSlider;
